import { Tooltip, Typography, makeStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React, { useEffect, useState } from 'react';
import DefaultSettings from './settings';
import InputLabel from '@material-ui/core/InputLabel';
import { getEnvVariable } from '../../../modules/environmentalList';

const defaults = {
    transformProps: {
        label: 'Name',
        value: 'Value'
    }
}
const useStyles = makeStyles({
    label: {
        width: '100%', // Adjust as needed
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
});

export default function RadioButtonsGroup(props) {
    const classes = useStyles();
    const { value, handleFieldValue, extraProps, required, error, shareProps, tooltip, contexthelp, className, row, disabled, IsSelectable, ...otherProps } = props
    const { label, helperText, items, name, fullWidth, ...otherConfigs } = otherProps
    const { transformProps } = extraProps || {}
    const [isLabelTooLong, setIsLabelTooLong] = useState(false);

    useEffect(() => {
        // Check if the label is too long
        const labelElement = document.createElement('div');
        labelElement.style.position = 'absolute';
        labelElement.style.visibility = 'hidden';
        labelElement.style.whiteSpace = 'nowrap';
        labelElement.innerText = label;
        document.body.appendChild(labelElement);
        const labelWidth = labelElement.offsetWidth;
        document.body.removeChild(labelElement);

        if (labelWidth > 500) { // Adjust the width threshold as needed
            setIsLabelTooLong(true);
        } else {
            setIsLabelTooLong(false);
        }
    }, [label]);

    const isDisabled = (each) => {
        if (each.IsSelectable)
            return each.IsSelectable === 'Y' ? false : true
        else return false
    }

    let tlabel = (
        <Typography
            variant={((isLabelTooLong && value) ? 'caption' : 'h6')}
            color={error ? 'red' : ''}
            style={{
                display: 'block', whiteSpace: 'normal', wordWrap: 'break-word',
                color: isLabelTooLong ? '#6c757d' : ''
            }}
        >
            {label}
            {required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
            {tooltip && (
                <Tooltip title={tooltip ? tooltip : null} placement="bottom-start">
                    <HelpOutlineIcon
                        color='secondary'
                        fontSize="small"
                        style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
                        onClick={(evt) => contexthelp ? DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()}
                    />
                </Tooltip>
            )}
        </Typography>
    );

    return (
        <FormControl key={name} fullWidth={fullWidth ? fullWidth : true} error={error} {...otherConfigs} disabled={disabled}>
            {isLabelTooLong && value && (
                <div>
                    {tlabel}
                </div>
            )}
            <InputLabel shrink className={classes.label}>
                {!isLabelTooLong || !value ? tlabel : ''}
            </InputLabel>
            <div className={value ? 'pt-2' : 'pt-4'}></div>
            <RadioGroup className="text-secondary" key={name + value} value={value} name={name} onChange={handleFieldValue} row={row == false ? row : true}>
                {
                    items && items.map((each, index) => {
                        const { label, value } = transformProps ? transformProps : defaults.transformProps
                        const name = each[label]
                        const key = each[value]
                        return <FormControlLabel
                            disabled={disabled ? disabled : isDisabled(each)}
                            key={index.toString()}
                            value={key}
                            control={<Radio color="primary" />}
                            style={{ color: 'black' }}
                            label={<Typography variant='caption' style={{ fontSize: '12px', fontWeight: '600' }}>{name}</Typography>}
                            labelPlacement="end"
                        />
                    })
                }
            </RadioGroup>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
}